import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
        <p>	&#169; 2022 #VANLIFE</p>
    </div>
  )
}

export default Footer